module.exports = __webpack_public_path__ + "static/img/introduceB2.d928e1c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/introduceB2.png
// module id = SDja
// module chunks = 0